// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 749 ? "popout-coordinator" : chunkId) + "." + {"453":"822bd1c5","749":"aaf9330f"}[chunkId] + ".chunk.js";
};